import MyAccountMessages from './MyAccountMessages'

export default MyAccountMessages
// eslint-disable-next-line import/export
export * from './MyAccountMessages'
